module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-2@2x__f2b9de78d947fe7716c91db1994e6954.png";